export enum SportWagerStatusEnum {
  Lose = 0,
  Win = 1,
  Push = 2,
  NoNet = 3,
  NAIfBets = 4, //(child dont Apply)
  NAPitchingChange = 5,
  NACancel = 6,
  NAShort = 7,
  NAVoid = 8,
  WinByOneFourth = 9,
  LoseByOneFourth = 10,
  WinByThreeQuarters = 11,
  LoseThreeQuarters = 12,
  Pending = 255,
}
